import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert } from 'react-icons/lu';
import { cx } from './cx';

export function Spinner({ className, label }) {
  return <span className={cx('spinner', className)} role={label ? 'status' : undefined} aria-label={label} />;
}

export function Skeleton({ width, height = 14, className, style }) {
  return <span className={cx('skeleton', className)} style={{ width, height, ...style }} aria-hidden="true" />;
}

export function EmptyState({ icon: Icon, title, text, action, className }) {
  return (
    <div className={cx('empty-state', className)}>
      {Icon && <Icon className="empty-state__icon" aria-hidden="true" />}
      <p className="empty-state__title">{title}</p>
      {text && <p className="empty-state__text">{text}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}

const ALERT_ICONS = { danger: LuCircleAlert, success: LuCircleCheck, warning: LuTriangleAlert, info: LuInfo };

export function Alert({ tone = 'info', children, action, className }) {
  const Icon = ALERT_ICONS[tone] ?? LuInfo;
  return (
    <div className={cx('alert', tone !== 'info' && `alert--${tone}`, className)} role={tone === 'danger' ? 'alert' : 'status'}>
      <Icon aria-hidden="true" />
      <div className="alert__body">{children}</div>
      {action && <div className="alert__action">{action}</div>}
    </div>
  );
}
